import { FC } from 'react';
import { Box, Flex } from '@chakra-ui/react';

import countriesList from 'common/countries/countriesList';
import { AvailableLanguages } from 'common/hooks/useCurrentLanguage/types';
import * as Form from 'components/_core/form';

import { useLanguageContext } from './hooks';
import locales from './locales';

const LanguageSwitch: FC = () => {
  const { lang, setLang } = useLanguageContext();

  const options = [
    {
      // @ts-expect-error countriesList.FR is possibly 'undefined'.
      flag: countriesList.FR.flag,
      label: locales.french,
      value: 'fr',
    },
    {
      // @ts-expect-error countriesList.GB is possibly 'undefined'.
      flag: countriesList.GB.flag,
      label: locales.english,
      value: 'en',
    },
  ] satisfies {
    flag: string;
    label: string;
    value: AvailableLanguages;
  }[];

  const onChange = (selectedLang: AvailableLanguages | null) => {
    if (selectedLang) {
      setLang(selectedLang);
    }
  };

  return (
    <Flex justifyContent="flex-end" marginBottom="space-24">
      <Box width="160px">
        <Form.SunshineSelect
          components={{
            Option: Form.SunshineSelect.components.LanguageOption,
            SingleValue: Form.SunshineSelect.components.LanguageSingleValue,
          }}
          onChange={(option) => onChange(option?.value ?? null)}
          options={options}
          value={options.find((option) => option.value === lang)}
        />
      </Box>
    </Flex>
  );
};

export default LanguageSwitch;
